import React, { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Navbar_render.css";
import "../../../../UiComponents/Navbar.css";
import { useSelector } from "react-redux";
import { BackArrowIcon2, New_ScrollX2025 } from "../../../../assets/icons";
import Setting from "../../../Setting/Setting";

export default function Navbar_back_btn({
  closeModal,
  isUpgradeOpen,
  isOpen,
}) {
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const firstSegment = location.pathname.split("/")[1];
  const lastSegment = pathSegments[pathSegments.length - 1];
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const [isSettingOpen, setIsSettingOpen] = useState(false);
  const profileBtnRef = useRef(null);
  const project = useSelector((state) => state.project);

  const getUserInitials = () => {
    const firstName = userInfo?.firstName?.trim() || "";
    if (firstName) return firstName.charAt(0).toUpperCase();
    return "U";
  };

  const getBackgroundColor = () => "#7c5cff26";

  return (
    <>
      <nav className="w-full h-full render_navbar Pro_navbarDash flex flex-wrap items-center justify-between text-slate-200 focus:text-sly-700 drop-shadow-2xl">
        <div className="w-full h-full flex flex-wrap items-center justify-between px-[16px]">
          <div className="flex items-center w-[15%]">
            <button type="button" className="flex items-center" onClick={() => closeModal()}>
              <img className="w-[11px] cursor-pointer" src={BackArrowIcon2} alt="" />
            </button>

            <div className="flex items-center pl-[7%]">
              <img className="w-[35px]" src={New_ScrollX2025} alt="ScrollX" />
              <span className="ml-[10px] Syne700 text-xl tracking-wide">
                ScrollX.io
              </span>
            </div>
          </div>

          <div className="w-[55%] flex justify-center items-center">
            <h1 className="manrope-600 text-[15px] text-white">
              {isUpgradeOpen || isOpen
                ? "Choose Plan"
                : lastSegment === "myrenders"
                  ? "My Renders"
                  : firstSegment === "more_info"
                    ? "Billing Info"
                    : project?.title?.toUpperCase()}
            </h1>
          </div>

          <div className="flex justify-end w-[15%]">
            <button
              ref={profileBtnRef}
              type="button"
              className="w-[35px] h-[35px] border-[1px] border-[#7c5cff4d] hover:bg-[#7c5cff40] rounded-full transition-colors"
              onClick={() => setIsSettingOpen((open) => !open)}
              style={{ backgroundColor: getBackgroundColor() }}
              aria-expanded={isSettingOpen}
              aria-haspopup="true"
            >
              <div className="flex justify-center items-center text-[#c4b2ff] text-xl font-body w-[35px] h-[35px] rounded-full">
                <span className="font-body text-[#c4b2ff] text-lg text-center">
                  {getUserInitials()}
                </span>
              </div>
            </button>
          </div>
        </div>
      </nav>
      <Setting
        isSettingOpen={isSettingOpen}
        setIsSettingOpen={setIsSettingOpen}
        anchorRef={profileBtnRef}
      />
    </>
  );
}
